<div class="title">
  <img src="{{ filter.icon }}" *ngIf="filter.icon" />
  <h4>{{ filter.title | translate }}</h4>
</div>
<div class="content">
  <div class="categories">
    <ng-container *ngFor="let elem of filter.getValues()">
      <div
        (click)="onFilterSelectValue(elem.value)"
        class="category"
        [class.selected]="filter.isSelectedValue(elem.value)"
      >
        <p class="label">{{ elem.label | translate }}</p>
      </div>
      <p
        *ngIf="elem.info !== ''"
        [class.hidden]="!filter.isSelectedValue(elem.value)"
        class="hours"
      >
        {{ elem.info | translate }}
      </p>
    </ng-container>
  </div>
  <div *ngIf="filter.hasSubfilters()" class="subfilters">
    <latitude-toggle
      [label]="filter.toggleText | translate"
      [checked]="subfiltersDisabled"
      (change)="toggleSubfilters()"
    >
    </latitude-toggle>
    <div
      class="multiwrapper custom-scrollbar"
      [class.enabled]="!subfiltersDisabled"
    >
      <div
        class="target dropdown"
        [class.open]="openTargetFiltersDropdown"
        *ngIf="!subfiltersDisabled"
      >
        <span
          class="current"
          [class.has-value]="compareDelivery"
          (click)="toggleTargetFiltersDropdown()"
          (appClickOutside)="openTargetFiltersDropdown = false"
        >
          <span class="name">
            {{ 'by' | translate }} {{ selectedSubfilterTitle | translate }}
          </span>
        </span>
        <div class="selector">
          <div class="header">
            <p>{{ 'Filter target by...' | translate }}</p>
          </div>
          <ul class="custom-scrollbar" [ngStyle]="{ maxHeight: '150px' }">
            <li
              *ngFor="let subfilter of getSubfilters(filter)"
              [class.selected]="selectedSubfilterTitle === subfilter.title"
              (click)="selectSubFilters(subfilter)"
            >
              <span>{{ subfilter.title | translate }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="wrapper">
        <div
          *ngFor="let subfilter of filter.subfilters; let i = index"
          [id]="subfilter.id"
          class="subfilter"
          [class.selected]="selectedSubfilterTitle === subfilter.title"
          [class.multiple]="subfilter.multiple"
        >
          <div
            *ngFor="let elem of subfilter.getValues()"
            class="category"
            [class.selected]="subfilter.isSelectedValue(elem.value)"
          >
            <p class="label" (mousedown)="onFilterSelectValue(elem.value, i)">
              {{ elem.label | translate }}
            </p>
          </div>
          <div *ngIf="hasHelp(subfilter.help)" class="help">
            <span
              class="toggle"
              [class.showing]="subfilter.help.showing"
              (click)="toggleHelp()"
              >{{ subfilter.help.title | translate }}</span
            >
            <ul
              class="subhelp"
              *ngIf="
                _showSubfilterHelp && subfilter.title === selectedSubfilterTitle
              "
            >
              <ng-container *ngFor="let value of getSubFilterHelp()">
                <li *ngIf="value.help">
                  <p>
                    <strong>{{ value?.label | translate }}: </strong>
                    {{ value?.help | translate }}
                  </p>
                </li>
              </ng-container>
            </ul>
            <span
              class="toggle hide"
              *ngIf="hasHelp(subfilter.help) && subfilter.help.showing"
              (click)="toggleHelp()"
              >{{ 'Hide' | translate }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="hasHelp(filter.help) && subfiltersDisabled" class="help">
    {{ filter.help | translate }}
  </div>
</div>
